<script setup lang="ts">
import { computed } from 'vue'
import AppDialog from './AppDialog.vue'
import { visible, current, handleNotifyConfirm, closeNotify, progress, showProgress, dismissible } from '@/stores/notify'

const title = computed(() => current.value.title)
const message = computed(() => current.value.message)
const confirmText = computed(() => current.value.confirmText)
const variant = computed(() => current.value.variant ?? 'primary')
const progressPercent = computed(() => progress.value)
const showProgressBar = computed(() => showProgress.value)
const canClose = computed(() => dismissible.value && !showProgress.value)
</script>

<template>
  <AppDialog
    v-model="visible"
    :title="title"
    :message="message"
    :confirm-text="confirmText"
    :variant="variant"
    :show-progress="showProgressBar"
    :progress="progressPercent"
    :dismissible="canClose"
    @confirm="handleNotifyConfirm"
    @close="closeNotify"
  />
</template>
